export default __webpack_public_path__ + "static/media/Stock-Locator.73382f65.png";